import { OpgavepakkeOpgave } from './OpgavepakkeOpgave';
import { Vejledning } from './Vejledning';
export class Opgavepakke {
        public id: string;
        public titel: string;
        public skoleaar: number;
        public opgavepakkeOpgaver: OpgavepakkeOpgave[];
        public createdDate: Date;
        public lastChangedDate: Date;
        public synligFraDato: Date;
        public vejledning: Vejledning;
}   



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/models/Opgavepakke.ts